import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Benefits = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className="wpo-benefits-section">
            <h2>Why Partner with Knoweb?</h2>
            <div className="row">
                <div className="col-lg-12 col-12">
                    <div className="wpo-benefits-item">
                        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography>
                                    We take time to listen and understand your business before building anything
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    At Knoweb, we don’t jump straight into development. We start by truly understanding your challenges, your goals, and how you work. That way, we can craft solutions that actually solve problems, not just look good on paper.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                            >
                                <Typography>
                                    We provide everything you need from one place so you don’t have to manage multiple teams
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Whether it's design, frontend, backend, testing, or support, Knoweb gives you a complete solution without the headache of working with several vendors. This makes your life easier and ensures smoother results.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header"
                            >
                                <Typography>
                                    You will always be kept in the loop with honest communication and regular updates
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    We believe in transparency and clear communication. You’ll always know what’s happening with your project, what’s next, and what we need from you. No surprises and no confusion.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel4bh-content"
                                id="panel4bh-header"
                            >
                                <Typography>
                                    Everything we build is made to scale and last for the long run
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Your software or website isn’t just for today. We build solutions that grow with your business, stay secure, and are easy to maintain in the future so you don’t run into problems down the road.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                            <AccordionSummary
                                expandIcon={""}
                                aria-controls="panel5bh-content"
                                id="panel5bh-header"
                            >
                                <Typography>
                                    We are more than developers, we are your long-term technology partner
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    When you work with Knoweb, you are not just hiring a team to build something and disappear. We stick around, support your growth, and help you adapt to changes with real guidance and care.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Benefits;
